export function ClientFooter() {
  return (
    <footer className="client-footer" role="contentinfo">

      <div className="container">
        <div className="client-footer-main">
          <div className="client-footer-brand">
            <svg className="client-footer-logo" viewBox="0 0 32 32" fill="none" aria-hidden="true">
              <rect width="32" height="32" rx="8" fill="currentColor" />
              <path d="M8 12h16M8 16h12M8 20h8" stroke="white" strokeWidth="2" strokeLinecap="round" />
            </svg>
            <div>
              <p className="client-footer-name">CV Berkah Nusa Sejati</p>
              <p className="client-footer-tagline">Warung Grosir Otomatis</p>
            </div>
          </div>

          <div className="client-footer-links">
            <nav aria-label="Tautan cepat">
              <h4 className="client-footer-heading">Tautan Cepat</h4>
              <ul className="client-footer-list">
                <li><a href="/" className="client-footer-link">Beranda</a></li>
                <li><a href="/order" className="client-footer-link">Mulai Belanja</a></li>
              </ul>
            </nav>

            <div className="client-footer-info">
              <h4 className="client-footer-heading">Info</h4>
              <ul className="client-footer-list">
                <li><span className="client-footer-text">Pemesanan via Web</span></li>
                <li><span className="client-footer-text">Cetak Struk Otomatis</span></li>
                <li><span className="client-footer-text">Mobile Friendly</span></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="client-footer-bottom">
          <p className="client-footer-copyright">
            &copy; {new Date().getFullYear()} CV Berkah Nusa Sejati. Hak cipta dilindungi.
          </p>
          <p className="client-footer-credit">
            Website by <a href="mailto:giovaniramdano@gmail.com">VnyCompany</a>
          </p>
        </div>
      </div>
    </footer>
  )
}